<template>
  <div class="list-filter p-x-4 p-t-4 p-b-0">
    <div class="d-f">
      <div>
        <p class="card-content-title">Search</p>
      </div>
      <div class="ml-a">
        <Button @click="filterResetable ? resetFilter() : null" :disabled="!filterResetable" icon="sliders-off-24" class="small minimal-border-radius only-text blue keep-hover">Clear filters</Button>
      </div>
    </div>
    <template v-if="filter.filters.length > 0">
      <Tag v-for="filter in filter.filters" :key="filter.value.value" :icon="tagIcon(filter.type)" :removeable="true" class="m-r-2" @remove="$emit('removeFilter', filter)">{{ filter.value.string }}</Tag>
    </template>
    <template v-else>
      <p style="line-height: 22px; padding-bottom: 10px; padding-left: 8px;">Not searching on anything</p>
    </template>
    <div class="d-f f-g fd-c fd-md-r m-t-2">
      <div class="f-1" v-if="!this.disableTypes">
        <p class="card-content-title">Type</p>
        <FormCheckbox v-for="(filterType, index) in filter.types" :key="`t${index}`" class="m-b-2" :clickable="true" :selected="filterType.selected" @input="filter.types[index].selected = !filter.types[index].selected" icon="check" :text="filterType.string" />
      </div>
      <div class="f-1">
        <p class="card-content-title">Status</p>
        <FormCheckbox v-for="(filterStatus, index) in filter.status" :key="`s${index}`" class="m-b-2" :clickable="true" :selected="filterStatus.selected" @input="filter.status[index].selected = !filter.status[index].selected" icon="check" :text="filterStatus.string" />
      </div>
      <div class="f-1">
        <p class="card-content-title">Created</p>
        <FormRadio class="small no-border" :items="filterCreated" @input="filterCreated = $event.value" />
        <div class="d-f m-t-2 f-wrap" style="padding-left: 30px;">
          <form-date :disabled="filter.created.type === 'all'" type="date" :value="filter.created.from" icon="arrow-down-medium-24" class="m-r-2 m-b-2" @input="filter.created.from = $event" />
          <form-date :disabled="filter.created.type === 'all'" type="date" :value="filter.created.to" icon="arrow-down-medium-24" class="m-b-2" @input="filter.created.to = $event" />
        </div>
      </div>
      <div class="f-1"></div>
    </div>
  </div>
</template>

<script>

import Tag from '@/components/Common/Tag.vue';

export default {
  components: {
    Tag,
  },
  props: {
    filter: {
      type: Object,
      default: () => ({}),
    },
    disableTypes: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterCreated: {
      get() {
        return [
          { value: 'all', string: 'Show all' },
          { value: 'specific', string: 'Specific period' },
        ].map(type => ({ ...type, selected: type.value === this.filter.created.type }));
      },
      set(value) {
        this.filter.created.type = value;
      },
    },
    filterResetable() {
      return this.filter.types.findIndex(t => t.selected) >= 0 || this.filter.status.findIndex(t => t.selected) >= 0 || this.filter.created.type !== 'all' || this.filter.filters.length > 0;
    },
  },
  methods: {
    resetFilter() {
      this.filter.types = this.filter.types.map(t => ({ ...t, selected: false }));
      this.filter.status = this.filter.status.map(s => ({ ...s, selected: false }));
      this.filter.filters = [];
      this.filterCreated = 'all';
    },
    tagIcon(type) {
      switch (type) {
        case 'email':
          return 'phone-smart-24';
        case 'play_user_email':
          return 'user-24';
        case 'transaction_id':
          return 'dollar-24';
        case 'product_id':
          return 'tshirt-product-24';
        case 'item':
          return 'stream-24';
        default:
          break;
      }
      return '';
    },
  },
};
</script>
